import { createContext } from 'react';
import { CalendarDay, DayButtonProps } from 'react-day-picker';

export const DayContext = createContext<DayButtonProps>({
	day: {} as CalendarDay,
	modifiers: {},
});
